import EmptyDottedIcon from '@assets/icons/empty-dotted.svg';
import i18n from '@/utils/i18n';
import React from 'react';
import { EmptyState } from '@experiences/components/empty-state';
import { useTheme } from '@/contexts/theme-context';

export const PricingCustomerDetailTableEmptyComponent = () => {
  const theme = useTheme();

  return (
    <EmptyState
      description={i18n.t('pricing.customer_detail.empty.description')}
      iconElement={
        <EmptyDottedIcon
          fill={theme.sk.color.icon.primary}
          height={48}
          width={48}
        />
      }
      title={i18n.t('pricing.customer_detail.empty.title')}
    />
  );
};
